import React from 'react';
import { useQuery } from '@apollo/client';
import {
    GET_RESOURCE_LIBRARY_ASSET_ITEM_QUERY,
    getResourceLibraryAssetItemQueryVariables,
} from '../../graphql/pimcore/modules/resourceLibrary/queries/getResourceLibraryAssetItemQuery';
import pimcoreClient from '../../graphql/pimcore/apollo/pimcoreClient';
import { transformResourceLibraryAssetItemResponse } from '../../graphql/pimcore/modules/resourceLibrary/tools/transformResourceLibraryAssetItemResponse';
import { ResourceLibraryAssetItem } from '../../graphql/pimcore/modules/resourceLibrary/types/resourceLibraryItems';
import { findLocale, LocaleCode } from '../../utils/Locale';
import PdfAssetViewer from './PdfAssetViewer';
import HtmlAssetViewer from './HtmlAssetViewer';

interface AssetResourcePageProps {
    id: string;
    locale: string;
}

const AssetResourcePage: React.FC<AssetResourcePageProps> = ({ id, locale }) => {
    const localeCode: LocaleCode = findLocale(locale).locale;
    const { loading, error, data } = useQuery(GET_RESOURCE_LIBRARY_ASSET_ITEM_QUERY, {
        variables: getResourceLibraryAssetItemQueryVariables(localeCode, Number(id)),
        client: pimcoreClient,
    });

    React.useEffect(() => {
        if (error) {
            console.error('GraphQL Asset Query Error:', error);
        }
    }, [error]);

    if (loading) return <div className="mid-width">Loading...</div>;
    if (error) return <div className="mid-width">Error: {error.message}</div>;

    const assetItem: ResourceLibraryAssetItem | null = transformResourceLibraryAssetItemResponse(
        data,
        localeCode
    );
    if (!assetItem) return <div className="mid-width">Asset item not found.</div>;

    const asset = assetItem.asset;
    if (!asset) return <div className="mid-width">No asset available.</div>;

    if (asset.mimeType === 'application/pdf') {
        return <PdfAssetViewer assetItem={assetItem} />;
    } else if (asset.mimeType === 'text/html') {
        return <HtmlAssetViewer assetItem={assetItem} />;
    } else {
        return (
            <div className="mid-width">
                Unsupported asset mimeType: {asset.mimeType}. Only PDF and HTML assets are
                supported.
            </div>
        );
    }
};

export default AssetResourcePage;
